var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"visible":_vm.visible,"width":"360px","append-to-body":""},on:{"update:visible":function($event){_vm.visible=$event}}},[_c('div',[_c('ReceiptGenerator',{attrs:{"data":_vm.data,"template-url":"/ar_receipt.png"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }